/**
 * BusyLabel — содержимое кнопки, которое не меняет её ширину во время загрузки.
 *
 * Раньше кнопки меняли подпись на «Загрузка…» / «Сохранение…»: ширина прыгала,
 * соседние кнопки в подвале модалки дёргались. Здесь подпись остаётся в
 * разметке (невидимой) и держит размер, а спиннер ложится поверх по центру.
 *
 * Кнопке-родителю нужен `position: relative` — компонент ставит его сам через
 * обёртку, поэтому снаружи достаточно просто вложить:
 *   <button className="btn btn-primary" disabled={busy}>
 *     <BusyLabel busy={busy} label={t('common.loading')}>{t('fleet.exportBtn')}</BusyLabel>
 *   </button>
 *
 * light — белый спиннер для залитых кнопок (btn-primary), иначе акцентный.
 */
import React from 'react';

export default function BusyLabel({ busy, label, light = true, children }) {
  return (
    <span style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
          aria-busy={busy || undefined}>
      <span style={{ visibility: busy ? 'hidden' : 'visible', display: 'inline-flex', alignItems: 'center', gap: 6 }}>
        {children}
      </span>
      {busy && (
        <span className="spinner" role="status" aria-label={label}
              style={{
                position: 'absolute', top: '50%', left: '50%', width: 16, height: 16, margin: '-8px 0 0 -8px',
                ...(light ? { borderColor: 'rgba(255,255,255,0.35)', borderTopColor: '#fff' } : null),
              }} />
      )}
    </span>
  );
}
